import { updateSubmittingOrgStatusWatcher } from 'modules/settings/submodules/clients/submittingOrg/components/UpdateStatusSelect/store/sagas';
import { createSubmittingOrgWatcher } from 'modules/settings/submodules/clients/submittingOrg/components/CreateSubmittingOrg/store/sagas';
import { updateSubmittingOrgWatcher } from 'modules/settings/submodules/clients/submittingOrg/components/EditSubmittingOrg/store/sagas';

export const submittingOrgSagas = [
    updateSubmittingOrgStatusWatcher,
    createSubmittingOrgWatcher,
    updateSubmittingOrgWatcher,
];
